import { Attributes, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionEventLookup extends ModelBase {
    public corporateActionEventID: number = 0;

    public corporateActionStatusID: number = 0;

    public staticServiceProviderFileGroupingID: number = 0;

    public broker: string = "";

    public instrument: string = "";

    @Attributes.Date()
    public dateEvent: Date | null = null;

    public rawEventType: string = "";

    public rawCorporateActionType: string = "";

    public rawExchange: string = "";

    public rawUnderlyingSecurityCode: string = "";

    public currency: string = "";

    @Rules.StringLength(500)
    public researcherComment: string = "";

    @Rules.StringLength(500)
    public enactmentComment: string = "";

    public status: string = "";

    public isDeleted: boolean = false;
}